function reqIdleCallback(callback, timeout) {
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(callback, {
      timeout: timeout || 1000
    });
  } else {
    setTimeout(callback, 0);
  }
}

/**
* 生成一个指定长度的随机字符串，用于生成UUID
*/
function getUUID() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
  var current = arguments.length > 1 ? arguments[1] : undefined;
  current = current ? current : '';
  return length ? getUUID(--length, '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'.charAt(Math.floor(Math.random() * 60)) + current) : current;
}

/**
* 对象的1层merge
*/
function assign(o1, o2) {
  for (var i in o2) {
    o1[i] = o2[i];
  }
  return o1;
}

var SDK_VERSION = '0.2.0';
var CONFIG_MAX_URL_LIMIT = 'maxUrlLength';
// 必要参数的配置key
var CONFIG_REQUIREDFIELDS = 'requiredFields';
var URL_LIMIT = 30000;
// 需要上报的全局维度白名单
var TAGS_WHITE_LIST = [
// 主动设置
"pid", 'page_id', 'env', 'username', 'uid',
// 主动设置（可选)
'sid',
// 自动采集
'device_id', 'net_type', 'downlink', 'sdk_version', 'origin_url', 'title', 'sr', 'dpi', 'pv_id', 'ua', 'app_name', 'app_version', 'os', 'os_version'];

/**
* 将变量转换成字符串
*/
var itemToString = function itemToString(v) {
  var type = Object.prototype.toString.call(v);
  if (type === '[object String]') {
    return v;
  } else if (type === '[object Number]' || type === '[object Boolean]') {
    return v.toString();
  } else if (type === '[object Object]' || type === '[object Array]') {
    return JSON.stringify(v);
  }
  return JSON.stringify(v);
};

/**
  * 将对象中的每一个变量转换成字符串
  * returns
  */
var ObjToString = function ObjToString(obj) {
  var r = {};
  for (var i in obj) {
    var v = obj[i];
    if (v !== undefined && v !== '' && v !== null) {
      r[i] = itemToString(v);
    }
  }
  return r;
};

/**
* 将对象转换成查询字符串，要求对象的key必须不带特殊字符
*/
var objToQS = function objToQS(obj) {
  var qs = [];
  for (var i in obj) {
    qs.push("".concat(i, "=").concat(encodeURIComponent(itemToString(obj[i]))));
  }
  return qs.join('&');
};

/**
* 是否有必要参数没有设置好，判断对应key是否为undefined
*/
function isRequiredFieldNotReady(config) {
  // requiredField是否已经存在，pid默认为必要参数
  var requiredFields = (config[CONFIG_REQUIREDFIELDS] || []).concat(['pid']);
  return requiredFields.some(function (field) {
    return config[field] === undefined;
  });
}
function EeveeTrackerCore(config) {
  // 断网时的缓存队列
  this._offlineQueue = [];
  // 批量缓存队列
  this._queue = [];
  // requireFields未ready之前保存的队列
  this._reqQueue = [];
  // 插件
  this._plugins = {};
  // 配置
  this._config = {
    sdk_version: SDK_VERSION,
    pv_id: getUUID()
  };

  // 保存原始console方法
  this._originConsoleMethods = {};
  if (config) {
    this._config = assign(this._config, config);
  }
}
EeveeTrackerCore.prototype = {
  constructor: EeveeTrackerCore,
  /**
  * 发送队列中的所有埋点
  * @private
  */
  _sendAll: function _sendAll() {
    if (!this._queue.length) {
      return;
    }
    var limit = this._config[CONFIG_MAX_URL_LIMIT] || URL_LIMIT;
    var config = this._getSendConfig();

    // 如果一次能发送完
    var fullQS = this._processData(this._queue, config);
    if (fullQS.length < limit) {
      this._queue = [];
      this._dispatch(fullQS);
      return;
    }

    // 否则
    var logs = [];
    var body;
    while (this._queue.length) {
      //如果1条记录就超过长度的话还是发送
      logs.push(this._queue.shift());
      body = this._processData(logs, config);
      if (body.length > limit) {
        if (logs.length > 1) {
          this._queue.push(logs.shift());
          body = this._processData(logs, config);
        }
        break;
      }
    }
    this._dispatch(body);
    if (this._queue.length) {
      this._sendAll();
    }
  },
  /**
  * @method _send
  * @params data {Object} 需要发送的数据
  * @params data.logs (Array} 需要发送的样本列表
  * @params data.config {0bject} 全局配置
  * @params isCombo {Boolean} 是否需要combo发送
  * @private
  */
  _send: function _send(data, isCombo) {
    if (isCombo === false) {
      // regIdleCallback(()=>{
      this._dispatch(this._processData([data]));
      //})
    } else {
      // 空闲时发送全部缓存队列
      this._queue.push(data);
      reqIdleCallback(this._sendAll.bind(this));
    }
  },
  /**
  * 获取需要上报的维度，并转换成字符串
  * @private
  * */
  _getSendConfig: function _getSendConfig() {
    var config = {};
    var et_config = this._config;
    for (var key in et_config) {
      (TAGS_WHITE_LIST.includes(key) || key.indexOf('dim') === 0) && (
      //空字符串、null、undefined 不上报
      et_config[key] || et_config[key] === 0) && (config[key] = itemToString(et_config[key]));
    }
    return config;
  },
  /**
  * 为埋点增加全局配置参数
  * @params logs {Array} 需要发送的日志列表
  * @private
  */
  _processData: function _processData(logs, config) {
    config = config || this._getSendConfig();
    var qs = objToQS(config);
    qs += '&msg=' + encodeURIComponent(logs.map(function (log) {
      return objToQS(log);
    }).join('|'));
    return qs;
  },
  /*
  * 修改全局配置
  * 在更新配置前
  */
  setConfig: function setConfig(key, value) {
    var _this = this;
    var setConfig = function setConfig() {
      if (value !== undefined) {
        _this._config[key] = value;
      } else {
        for (var i in key) {
          if (Object.prototype.toString.call(key[i]) === '[object Object]') {
            _this._config[i] = assign(_this._config[i] || {}, key[i]);
          } else {
            _this._config[i] = key[i];
          }
        }
      }
    };
    // 有因为必要参数没有Ready 而缓存的埋点时，先设置Config，然后判断必要参数是否已经ready，如果ready 就清空缓存的队列
    // 当存在这样的缓存队列时，所有埋点会携带最后的config信息发送
    if (this._reqQueue.length) {
      setConfig();
      if (
      // 当前配置项屬于必要配置
      // requiredFields. indexof(k) 1==-1 8&
      //必要配置都已经存在
      !isRequiredFieldNotReady(this._config)) {
        this._reqQueue.forEach(function (args) {
          _this._send.apply(_this, args);
        });
        this._reqQueue = [];
      }
    } else {
      //在config变化前清空 历史队列中的埋点，保证埋点发送时会携带最新的config配置
      var isConfigChange = function () {
        if (value !== undefined) {
          return value !== _this._config[key];
        } else {
          for (var i in key) {
            if (key[i] !== _this._config[i]) {
              return true;
            }
          }
        }
        return false;
      }();
      if (isConfigChange) {
        this._sendAll();
      }
      setConfig();
    }
  },
  /**
  * 获取全局配置
  * @params key {String} 参数key
  */
  getConfig: function getConfig(key) {
    return key ? this._config[key] : this._config;
  },
  /**
  * 更新pv_id
  */
  updatePVID: function updatePVID() {
    this.setConfig('pv_id', getUUID());
  },
  getOriginConsoleMethod: function getOriginConsoleMethod(level) {
    return this._originConsoleMethods[level] || console[level];
  },
  /**
  * 发送埋点
  * 添加时间，并检查requiredFields是否ready
  * @params type {String} 埋点类型
  * @params data {Object} 埋点参数
  * @params config 配置参数 config.combo: 是否批量发送
  */
  log: function log(type) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!type) return;
    if (!config.enableEnv || config.enableEnv && (config.enableEnv === config.env || Array.isArray(config.enableEnv) && config.enableEnv.indexOf(config.env || '') > -1)) {
      data.ts = data.ts || new Date().getTime();
      data.ts = data.ts + '';
      data.type = type;
      data = ObjToString(data);
      // requiredField是否已经存在
      if (isRequiredFieldNotReady(this._config)) {
        this._reqQueue.push([data, config.combo]);
      } else {
        this._send(data, config.combo);
      }
    } else {
      console.warn('[ETracker]: 注意，当前env不在enableEnv中，当前日志未发送', arguments);
    }
  },
  /**
   * 挂载插件
   * const pluginApi = new EeveeTracker.use(PluginApi, {})
   * const [pluginApi, pluginPV] = new EeveeTracker.use([PluginApi, [PluginPV, { autoPv: false }]])
   * @param {Function|Array} plugins 插件原型或者插件列表
   * @param {Object} config 插件配置
   */
  use: function use(plugins, config) {
    var _this2 = this;
    if (Object.prototype.toString.call(plugins) === '[object Array]') {
      return plugins.map(function (plugin) {
        if (Object.prototype.toString.call(plugin) === '[object Array]') {
          var Fun = plugin[0];
          var _config = plugin[1];
          return _this2._plugins[Fun] = new Fun(_this2, _config);
        } else {
          return _this2._plugins[plugin] = new plugin(_this2);
        }
      });
    } else {
      return this._plugins[plugins] || (this._plugins[plugins] = new plugins(this, config));
    }
  }
};

var is_debug = location.href.indexOf('et_debug') > -1;
var apiUrl = 'https://yeying-gateway.apps-fp.danlu.netease.com/eevee-tracker/api/log';
var MAX_CACHE_QUEUE = 500;
// 防止发送数据量过大导致sendBeacon返回false进而请求pending的问题
var MAX_BEACON_SIZE_LIMIT = 10000;
function EeveeTracker() {
  var _this = this;
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config = {
    title: document.title,
    hash: location.hash,
    dpi: window.devicePixelRatio,
    sr: "".concat(window.screen.width, "x").concat(window.screen.height)
  };
  if (window.ET_CONFIG) {
    _config = assign(_config, window.ET_CONFIG);
  }
  if (config) {
    _config = assign(_config, config);
  }
  EeveeTrackerCore.call(this, _config);
  setTimeout(function () {
    window.postMessage({
      source: 'FROM_EEVEE_TRACKER',
      data: _this._config
    }, '*');
  }, 300);

  // Hash变化
  window.addEventListener('hashchange', function () {
    _this.setConfig('hash', location.hash);
  });
  // 网络变化
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (connection) {
    var updateNet = function updateNet() {
      // 更新网络状态
      _this.setConfig({
        downlink: connection.downlink,
        net_type: connection.effectiveType
      });
      //联网后发送缓存的埋点
      if (navigator.onLine && _this._offlineQueue.length) {
        _this._offlineQueue.forEach(function (item) {
          reqIdleCallback(function () {
            _this._dispatch(item);
          });
        });
        _this._offlineQueue = [];
      }
    };
    updateNet();
    connection.addEventListener('change', updateNet);
  }
  // title 变化，用Object.defineProperty会导致河览器的默认行为丢失
  // 监听类型不兼容时会报错，所以加try catch
  try {
    var observer = function observer() {
      var title = document.querySelector('title');
      if (!title) {
        return;
      }
      new MutationObserver(function () {
        _this.setConfig('title', document.title);
      }).observe(title, {
        childList: true,
        characterData: true,
        subtree: true
      });
    };
    if (document.querySelector('title')) {
      observer();
    } else {
      document.addEventListener('DOMContentLoaded', observer);
    }
  } catch (e) {}

  // 发送采集脚本加载完成前的埋点
  var queue = 'ET_QUEUE';
  if (Object.prototype.toString.call(window[queue]) === '[object Array]') {
    // TOD0：被一个实例消费后，是否需要清除
    window[queue].forEach(function (item) {
      if (typeof item === 'function') {
        item(_this);
      } else {
        _this[item.action].apply(_this, item.arguments);
      }
    });
  } else {
    window[queue] = [];
  }
  window[queue].push = function (item) {
    if (typeof item === 'function') {
      item(_this);
    } else {
      _this[item.action].apply(_this, item.arguments);
    }
  };
}
EeveeTracker.prototype = function () {
  var F = function F() {};
  F.prototype = EeveeTrackerCore.prototype;
  return new F();
}();
EeveeTracker.prototype.constructor = EeveeTracker;

/**
* 实际发送埋点请求
* @private
*/
EeveeTracker.prototype._dispatch = function (body) {
  if (navigator.onLine) {
    is_debug && this.getOriginConsoleMethod('log')('[ETracker] send', arguments);
    if (navigator.sendBeacon && body.length < MAX_BEACON_SIZE_LIMIT) {
      navigator.sendBeacon(apiUrl, body);
    } else {
      var xhr = new XMLHttpRequest();
      xhr.withCredentials = true;
      xhr.open('POST', apiUrl);
      xhr.send(body);
    }
  } else {
    if (this._offlineQueue.length > MAX_CACHE_QUEUE) {
      this._offlineQueue.shift();
    }
    this._offlineQueue.push(body);
  }
};

/**
 * 暴露给外部的log方法
 * 更新origin_url
 */
EeveeTracker.prototype.log = function () {
  var config;
  // 更新origin_url
  var newURL = location.href;
  if (newURL !== this.getConfig('origin_url')) {
    config || (config = {});
    config.origin_url = newURL;
  }

  // setConfig会进行队列检查，尽可能少执行
  config && this.setConfig(config);
  config = this.getConfig();
  if (!config.enableEnv || config.enableEnv && (config.enableEnv === config.env || Array.isArray(config.enableEnv) && config.enableEnv.indexOf(config.env) > -1)) {
    EeveeTrackerCore.prototype.log.apply(this, arguments);
    is_debug && this.getOriginConsoleMethod('log')('[ETracker] log', arguments);
  } else {
    is_debug && this.getOriginConsoleMethod('warn')('[ETracker]: 注意，当前env不在enableEnv中，当前日志未发送', arguments);
  }
};
var index = new EeveeTracker();

export { index as default };
